
import Vue from 'vue'
import axios from 'axios'
import { ClinicalSummaryPayload } from 'types/Sapphire_dto';

const ClinicalSummaryViewerPopup = Vue.extend({        
    name: "clinical-summary-queue-viewer",
            data: function () {
                return {
                    patientId: 0,
                    facId: 0,
                    openPopup: false,
                    pendingSummaries: [] as ClinicalSummaryPayload[],
                    summary_SortBy: "CreateDate",
                    summary_SortDesc: true,
                    summaryFields: [
                        {
                        key: "PatientName",
                        label: "Patient",
                        sortable: true,
                        },
                        {
                        key: "CreateDate",
                        label: "Create Date",
                        sortable: true,
                        formatter: (value) => {
                                return getFormattedDate(value);
                            },
                        },
                        {
                        key: "USERNAME",
                        label: "User",
                        sortable: true,
                        },
                        {
                        key: "ReportType",
                        label: "Type",
                        sortable: true,
                        tdClass: (value) => {   
                            let textVariant =  "dark"; 
                            switch (value) {
                            case 'RELEASE':                 
                                textVariant = "clinical-viewer-release";
                                break;
                            case 'EMERGENCY': 
                                textVariant = "clinical-viewer-emergency";
                                break;
                            case 'FULL RECORD':
                                textVariant = "clinical-viewer-full";
                                break;
                            }
                            return textVariant;
                          },
                        },
                        {
                        key: "StatusFlag",
                        label: "Status",
                        sortable: true,
                        formatter: (value) => {
                            let status = 'Pending';
                            if (value == 'I') {
                                status = 'In Process'
                            }
                            return status;
                            },
                        },
                        // {
                        // key: "Active",
                        // label: "Active",
                        // sortable: true,
                        // },
                        // { key: "actions", label: "Actions" },
                    ],
                };
            },
            mounted: function () {
                //mounted is an event in the lifecyle of a vue component
            },
            computed: {
                //no computeds yet
            },
            methods: {
                async show(patID: number) {
                    this.patientId= patID;
                    this.getPendingClinicalSummaries();
                    this.openPopup = true;
                },
                close: function () {
                    this.openPopup = false;
               },
               async getPendingClinicalSummaries() {
                    const response = await axios.post(
                    "../../../Common/Services/EmarClientOperations.svc/GetClinicalSummaryQueueUnprocessed_Viewer",
                    {
                         PAT_ID: this.patientId,
                    });
                    this.pendingSummaries = JSON.parse(response.data.d);
                },
    }
    });

    export type ClinicalSummaryViewerPopupRef = InstanceType<typeof ClinicalSummaryViewerPopup>;
    export default ClinicalSummaryViewerPopup;

    function getFormattedDate(value: Date) {
        var d = new Date(value);

        var month = "" + (d.getMonth() + 1);
        var day = "" + d.getDate();
        var year = "" + d.getFullYear();

        var hours = d.getHours();
        var minutes = d.getMinutes();
        var meridiem = d.getHours() > 12 ? "pm" : "am";

        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        let strMinutes = minutes < 10 ? "0" + minutes : minutes;

        let timePart = "" + hours + ":" + strMinutes + " " + meridiem;


        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;

        return [month, day, year].join("/") + ' ' + timePart;
    }
